// HU-32a-C4 y HU-32b-C4 (MG-ILE-63 · tarea 32a-6). «Sin acceso»: la persona entró con su cuenta
// pero no tiene roles, o la desactivaron.
//
// El texto lo arma el SERVIDOR (`sesion.texto_sin_acceso`, con el nombre y el correo del
// administrador del sistema) y aquí se pinta tal cual: la pantalla no lo compone (AT S3 §2.2.1).
// Sin menú ni pantalla vacía. Solo «Cerrar sesión», para poder entrar con otra cuenta.
import { LogOut, ShieldOff } from 'lucide-react';
import { Button, EmptyState } from '../components/ui';
import { PantallaDeEntrada } from './LoginSimulado';

export default function SinAcceso({ texto, onCerrarSesion }: {
  /** `sesion.texto_sin_acceso`. */
  texto: string;
  onCerrarSesion: () => void;
}) {
  return (
    <PantallaDeEntrada tituloDeLaPestana="Sin acceso" pie="Inicio de sesión con la cuenta corporativa">
      <EmptyState principal icon={ShieldOff} title={texto} data-testid="sesion-sin-acceso"
        action={<Button variant="secondary" icon={LogOut} onClick={onCerrarSesion} data-testid="sesion-salir">Cerrar sesión</Button>} />
    </PantallaDeEntrada>
  );
}
